<template>
  <div class="teacher-main-wrapper">
    <div
      style="padding: 30px 0 30px; margin: 0 auto; width: 1200px;"
      class="teacher-wrapper"
    >
        <div class="main-title">
          <div class="link-list">
            <span class="text">{{ menu.menu_name }}</span>
          </div>
          <a
            :href="`/teacherList.html?name=${menu.menu_name}&menuId=${menu.id}`"
            class="more-btn"
            style="margin-top: 6px"
          >
            <span class="btn-text">查看全部</span>
            <i class="iconfont icongengduo"></i>
          </a>
        </div>
        <div class="teacher-list">
            <template v-if="teacherList && teacherList.length">
              <TeacherCard v-for="teacherData in teacherList" :teacherData="teacherData" :key="teacherData.teacher_id" :menu="menu" class="teacher-card">
              </TeacherCard>
            </template>
          <div v-else class="no-data">
            <Empty type="people" />
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import config from "../../config";
import TeacherCard from "components/TeacherCard"
import { Empty } from 'zhs-components'
export default {
  components:{
    TeacherCard,
    Empty
  },
  props: {
    menu: Object
  },
  created() {
    this.getTeacherList();
  },
  //  watch: {
  //   menu() {
  //     this.getTeacherList();
  //   },
  // },
  data() {
    return {
      teacherList: [],
      dialogTeacherVisible: false,
      currentTeacher: {},
      abbr: config.abbr,
    };
  },
  methods: {
    async getTeacherList() {
      const list = await this.$http.getHomeTeachers({ num: this.menu.num, menu_id: this.menu.id });
      console.log('名师', list);
      this.teacherList = list;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/index";
.teacher-main-wrapper {
  min-height: 368px;
  font-size: 0;
}

.teacher-main-wrapper .teacher-wrapper {
  margin-right: 30px;
  vertical-align: top;
}

.teacher-main-wrapper .teacher-list {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  margin-top: 11px;
}
.main-title {
  display: flex;
  height: 28px;
  // overflow: hidden;
  .link-list {
    flex: 1;
    // margin-top: 6px;
    height: 28px;
    font-size: 20px;
    line-height: 28px;
    .text {
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      letter-spacing: 1px;
    }
  }
  .more-btn {
    flex: 0 0 74px;
    cursor: pointer;
    margin-right: 0;
  }
}
</style>